export default __webpack_public_path__ + "static/eficodeoffice-b8d6bb4a3d2322390ebf02388b38b2b0.png";